// font file
import { NextFontWithVariable } from 'next/dist/compiled/@next/font';
import { Vazirmatn } from 'next/font/google';

const vazirmatn = Vazirmatn({
  preload: true,
  subsets: ['arabic'],
  weight: ['100', '300', '400', '500', '700'],
  display: 'swap',
  variable: '--font-vazirmatn',
});

const fonts = [vazirmatn] as NextFontWithVariable[];

export default fonts;
